const menu = {
    label: 'Processos',
    icon: 'pi pi-fw pi-list',
    to: '/licitacoes/solicitacoes',
    matchChildren: true,
    rules: ['LICITACOES-00'],
};
export default menu;
